module.exports = __webpack_public_path__ + "assets/img/cqyy_img.d1402000.png";